import React from 'react'
import { Component, useEffect, useState } from "react";
import { useStream } from "react-fetch-streams";
import { useDispatch, useSelector } from "react-redux";
import {
  getAgentNumbers,
  hasAgentNumbers
} from "../../../app/modules/Ticker/api";
import * as callService from "../../../app/modules/Ticker/CallService";
import { getSetting } from "../../../app/modules/Ticker/helpers";
import * as helpers from "../../../app/util/helpers";
import useUserMediaStatus from '../../../app/modules/Ticker/sip/useUserMediaStatus';
let processingQueue = false;
const eventsQueue = [];

export const TickerInit = () => {
  const isLiveTickerEnabled = helpers.isFeatureEnabled('is_new_live_ticker_enabled');
  const isDuplicatedTab = useSelector(state => state.auth.is_duplicated_tab);
  return (
    <>
      {isLiveTickerEnabled && <_TickerInit isDuplicatedTab={isDuplicatedTab}/>}
      <_TickerAgentSessionInit />
    </>
  );
};
export const _TickerInit = (props) => {
  var dispatch = useDispatch();
  const userMediaEnabled = useUserMediaStatus();

  let params = { handleMessage: callService.handleCallServiceMessage };

  let url = `${process.env.REACT_APP_CALL_EVENTS_API_URL}`;

  url = url.replaceAll("{{user_api_key}}", getSetting("konnect_user_api_key"));

  const [changed, setChanged] = useState(1);

  const processQueue = async () => {
    if (processingQueue || eventsQueue.length == 0) return;

    let event = false;
    processingQueue = true;

    while ((event = eventsQueue.shift()) != undefined) {
      if (event.state == 100) {}
      if(props?.isDuplicatedTab) return; 
      if(!userMediaEnabled && helpers.isFeatureEnabledProfile('sip_url_flag')) return;
      if(helpers.isFeatureEnabledProfile("remove_konnect_dependency") && helpers.isFeatureEnabledProfile('sip_url_flag')) return;
      event.state = 100;
      await callService.handleCallServiceMessage(event.event, params, dispatch);
      event.state = 200;
    }
    processingQueue = false;
  };

  const onNext = async (res) => {
    let data1 = await res.text();
    let count = 0;

    var a = data1.split(/\{(.*?)\}/);
    for (var i = 0; i < a.length; i++) {
      var e = a[i];
      if (e.startsWith('"event_type":')) {
        if(e && e.includes("${")){
          e= e+'}"'
        }
        e = e.replaceAll('"${', '"');
        e = e.replaceAll('}"', '"');
        let es = "{" + e + "}";
        let event = JSON.parse(es);
        count = count + 1;
        eventsQueue.push({ state: 0, event });
      }
    }

    if (count > 0) {
      if (!processingQueue) {
        processQueue();
      }

      setTimeout(() => {
        processQueue();
      }, 1000);
    }
  };

  useStream(url, { onNext });

  return <></>;
};

export const _TickerAgentSessionInit = (props) => {
  var dispatch = useDispatch();

  useEffect(() => {
    if (helpers.isAgent() || helpers.isSuperVisor()) {
      const hasAgentNums = hasAgentNumbers();
      if (!hasAgentNums) {
        getAgentNumbers(dispatch);
      }
    }

    const onExit = () => {};

    return onExit;
  }, []);
  return <></>;
};
